export const enum Permissions {
  CREATE_STORY = 'CREATE_STORY',
  EDIT_COMPANY_STORY = 'EDIT_COMPANY_STORY',
  EDIT_USER = 'EDIT_USER',
  ACCESS_ADMIN_DASHBOARD = 'ACCESS_ADMIN_DASHBOARD',
}

export type AssignablePermission =
  | Permissions.CREATE_STORY
  | Permissions.EDIT_COMPANY_STORY
  | Permissions.EDIT_USER;

export interface IUserProfile {
  companyId: string;
  firstName: string;
  lastName: string;
  avatar?: string;
  job?: string;
  phone?: string;
}

export interface IUserResponse {
  uid: string;
  email: string;
  picture?: string;
  profile: IUserProfile;
  permissions?: Permissions[];
  team?: string[];
}

export interface IUser extends IUserResponse {
  canCreateStory: boolean;
  creationTime?: string;
}
